import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/Layout";
import { getEmployeeDetails } from "../../api/EmployeeApi";
import {
  getAllParcelStreetbyRouteAndEmployee,
  getAllRoutebyContractor,
  deleteParcelStreet,
  uploadBulk,
} from "../../api/RouteApi";
import ToastFile from "../../utils/ToastFile";
import { IoMdCloseCircle } from "react-icons/io";
import { FaEdit } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";
import { useNavigate } from "react-router-dom";
import ButtonLoader from "../../components/ButtonLoader";
import Loader from "../../components/Loader";
import { getOrderTypeLabel, ORDER_TYPES } from "../../constants/orderTypes";
import DragDropTable from "../../components/DragDropTable";

const GenerateParcelAddress = () => {
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [routes, setRoutes] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const fetched = useRef(false);
  const navigate = useNavigate();
  const [streetAddress, setStreetAddress] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [isButtonloading, setIsButtonloading] = useState(false);
  const [lastOrder, setLastorder]=useState(0)

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const fetchStreetsByRoute = async (routeId) => {
    if (!routeId) {
      setStreetAddress([]);
      return;
    }

    setIsloading(true);
    try {
      const res = await getAllParcelStreetbyRouteAndEmployee(
        routeId,
        user?.user_id,
      );
      if (res.status === 200) {
        const initialRows = res.data.data.streetData
        if (Array.isArray(initialRows)) {
      const sorted = [...initialRows].sort(
        (a, b) => a.order - b.order
      );
      setStreetAddress(sorted || []);
      const lastAddressOrder = sorted[sorted.length - 1]?.order || 0
        setLastorder(lastAddressOrder);
    }
        
      } else {
        ToastFile("Failed to fetch streets", "error");
        setStreetAddress([]);
      }
    } catch (err) {
      console.error("Error fetching streets:", err);
      ToastFile("Error fetching streets", "error");
      setStreetAddress([]);
    } finally {
      setIsloading(false);
    }
  };

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getRoute();

    const savedRoute = localStorage.getItem("selectedRoute");
    if (savedRoute) {
      const routeData = JSON.parse(savedRoute);
      setSelectedRoute(routeData);
      setValue("selectedRoute", routeData);
      fetchStreetsByRoute(routeData.value);
    }
  }, [setValue]);

  const getRoute = async () => {
    await Promise.all([
      getEmployeeDetails(user.id),
      getAllRoutebyContractor(user.tenant_id),
    ])
      .then(([employeeRes, routesRes]) => {
        if (employeeRes.status === 200 && routesRes.status === 200) {
          const employee = employeeRes?.data?.data;
          if (
            employee?.parcelSortRoutesList &&
            employee?.parcelSortRoutesList.length > 0
          ) {
            const options = routesRes?.data?.data?.routes
              .filter((route) =>
                employee.parcelSortRoutesList.includes(route._id),
              )
              .map((route) => ({
                value: route.route_id,
                label: route.routeName,
              }));
            setRoutes(options);
          } else {
            ToastFile(
              "You have no access to any routes. Please contact your contractor.",
              "info",
            );
          }
        } else {
          ToastFile("Failed to fetch employee details", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching employee details:", err);
        ToastFile("Error fetching employee details", "error");
      });
  };
  const handleEdit = (street) => {
    navigate("/generateParcelAddress/addrouteAddress", {
      state: {
        routeId: selectedRoute.value,
        editData: street,
        lastOrder: street.order
      },
    });
  };

  const handleDelete = async () => {
    try {
      const res = await deleteParcelStreet(deleteIndex);
      if (res.status === 200) {
        ToastFile("Street deleted successfully", "success");
        fetchStreetsByRoute(selectedRoute.value);
      } else {
        ToastFile("Failed to delete street", "error");
      }
    } catch (err) {
      console.error("Error deleting street:", err);
      ToastFile("Error deleting street", "error");
    } finally {
      setDeleteModal(false);
      setDeleteIndex(null);
    }
  };

  const generateAddress = async () => {
    const parcelAddressPayload = [];

    streetAddress.forEach((street) => {
      const start = Number(street.homeStart);
      const end = Number(street.homeEnd);
      const streetName = street.streetName;
      const type = street.sequenceType;

      // Determine direction
      const isAscending = [
        ORDER_TYPES[0].id,
        ORDER_TYPES[1].id,
        ORDER_TYPES[2].id,
      ].includes(type);

      const step = isAscending ? 1 : -1;
      const from = isAscending ? start : end;
      const to = isAscending ? end : start;

      // Determine odd/even filter
      const isOddOnly = [ORDER_TYPES[0].id, ORDER_TYPES[3].id].includes(type);
      const isEvenOnly = [ORDER_TYPES[1].id, ORDER_TYPES[4].id].includes(type);
      const allowAll = [ORDER_TYPES[2].id, ORDER_TYPES[5].id].includes(type);

      for (let i = from; isAscending ? i <= to : i >= to; i += step) {
        if (
          allowAll ||
          (isOddOnly && i % 2 === 1) ||
          (isEvenOnly && i % 2 === 0)
        ) {
          parcelAddressPayload.push({
            address: `${i} ${streetName}`,
            streetName,
            landmark: selectedRoute.label,
          });
        }
      }
    });
    handleUploadToServer(parcelAddressPayload);
  };

  const handleUploadToServer = async (addressData) => {
    setIsButtonloading(true);
    let payload = {
      data: addressData,
      route_id: selectedRoute?.value,
      tenant_id: user?.tenant_id,
      createdBy: user?.user_id,
      createdAt: new Date(),
      modifiedBy: user?.user_id,
      modifiedAt: new Date(),
      operation: "replace",
      isDuplicate: true,
    };
    await uploadBulk(payload)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Uploaded successfully", "success");
        } else {
          ToastFile("Failed to upload", "error");
        }
      })
      .catch(() => {
        ToastFile("Failed to upload", "error");
      })
      .finally(() => {
        setIsButtonloading(false);
        const route = {
          route_id: selectedRoute.value,
          routeName: selectedRoute.label,
        };
        navigate("/generateParcelAddress/paneladdress", {
          replace: true,
          state: { route },
        });
      });
  };

  return (
    <Layout>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
              <h3 className="mb-2 mb-md-0">Generate Route Address</h3>
            </div>

            <div className="row mb-3 d-flex justify-content-between">
              <div style={{ maxWidth: "400px" }}>
                <Form className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3">
                  <Form.Group className="flex-grow-1">
                    <Form.Label className="mb-2 fw-semibold">
                      Select Route
                    </Form.Label>
                    <Controller
                      control={control}
                      name="selectedRoute"
                      rules={{ required: false }}
                      render={({ field }) => (
                        <ReactSelect
                          {...field}
                          className=""
                          options={routes}
                          placeholder="Choose a route..."
                          onChange={(selected) => {
                            field.onChange(selected); // update form value
                            setSelectedRoute(selected);
                            // Save to localStorage
                            if (selected) {
                              localStorage.setItem(
                                "selectedRoute",
                                JSON.stringify(selected),
                              );
                              fetchStreetsByRoute(selected.value);
                            } else {
                              localStorage.removeItem("selectedRoute");
                              setStreetAddress([]);
                            }
                          }}
                        />
                      )}
                    />
                  </Form.Group>
                </Form>
              </div>
              <div style={{ maxWidth: "160px" }}>
                {selectedRoute && (
                  <Button
                    variant="outline-success"
                    onClick={() =>
                      navigate("/generateParcelAddress/addrouteAddress", {
                        state: { routeId: selectedRoute.value, lastOrder:lastOrder },
                      })
                    }
                    className="mt-2 mt-lg-0"
                  >
                    + Add Address
                  </Button>
                )}
              </div>
            </div>

            {/* Desktop Table */}
            {/* <div className="">
              <div className="table-responsive">
                <Table striped bordered hover className="table-sm">
                  <thead className="table-dark">
                    <tr style={{ textAlign: "center" }}>
                      <th className="text-wrap">Street Name</th>
                      <th className="text-wrap">Home Sequence</th>
                      <th className="text-wrap">Range Type</th>
                      <th className="text-nowrap">Action</th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <tbody>
                      <tr>
                        <td colSpan="4">
                          <Loader />
                        </td>
                      </tr>
                    </tbody>
                  ) : (
                    <tbody>
                      {streetAddress.length === 0 ? (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No Street Found
                          </td>
                        </tr>
                      ) : (
                        streetAddress.map((c, idx) => (
                          <tr key={idx}>
                            <td className="text-nowrap text-center">
                              <div>{c.streetName}</div>
                            </td>
                            <td className="text-nowrap text-center">
                              <div>
                                {c.homeStart} to {c.homeEnd}
                              </div>
                            </td>
                            <td className="text-wrap text-center">
                              <div>{getOrderTypeLabel(c.sequenceType)}</div>
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="btn btn-sm btn-outline-primary border-0"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(c)}
                              >
                                <MdModeEdit size={18} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger border-0"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setDeleteIndex(c._id);
                                  setDeleteModal(true);
                                }}
                              >
                                <MdDelete size={18} />
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  )}
                </Table>
              </div>
            </div> */}

            {/* Drag Cards */}
            <DragDropTable streetAddress={streetAddress} setStreetAddress={setStreetAddress} handleEdit={handleEdit} setDeleteIndex={setDeleteIndex} setDeleteModal={setDeleteModal}/>
            {streetAddress.length > 0 && (
              <div className="d-flex justify-content-center my-3">
                <Button
                  variant="success"
                  onClick={generateAddress}
                  style={{ minWidth: "200px" }}
                >
                  {isButtonloading ? (
                    <ButtonLoader width="20px" height="20px" />
                  ) : (
                    "Generate Address"
                  )}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this street?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default GenerateParcelAddress;
